import React from 'react';
import { GreenArrowIcon } from './ReversedFeaturesSection/GreenArrowIcon';
interface Feature {
  title: string;
  description: string;
}
interface ReversedFeaturesSectionProps {
  'data-id'?: string;
  title?: string;
  subtitle?: string;
  flagImageUrl?: string;
  backgroundImageUrl?: string;
  features?: Feature[];
  accentColor?: string;
  backgroundColor?: string;
  borderColor?: string;
  className?: string;
}
const defaultFeatures: Feature[] = [{
  title: 'Lightning-Fast Insights',
  description: 'Ask questions in plain language and get immediate responses.'
}, {
  title: 'Natural Language Queries',
  description: 'No technical skills needed - just ask like you are talking to a colleague.'
}, {
  title: 'Proactive Insights',
  description: 'AI suggests questions and highlights opportunities you might miss. (coming soon)'
}, {
  title: 'Accelerated Growth',
  description: 'Make data-driven decisions faster with complete business context.'
}];
export function ReversedFeaturesSection({
  'data-id': dataId,
  title = 'Meet Naiomi.ai Your AI eCommerce Analyst',
  subtitle,
  flagImageUrl = 'https://cms.mistral.ai/assets/56971484-bbff-4ab7-9e4e-c034bc321f84.svg',
  backgroundImageUrl = 'https://cms.mistral.ai/assets/c7627522-667c-4bb5-a16c-4580f3767b64',
  features = defaultFeatures,
  accentColor = 'text-orange-500',
  backgroundColor = 'bg-orange-50',
  borderColor = 'border-orange-200',
  className = ''
}: ReversedFeaturesSectionProps) {
  return <section className={`relative w-full ${backgroundColor} text-gray-800 py-6 ${className}`} data-id="element-477">
      {/* Background Image */}
      <div className="absolute inset-0 -z-10 max-w-7xl mx-auto" data-id="element-478">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 h-full" data-id="element-479">
          <div data-id="element-480"></div>
          <div className="relative h-full min-h-[500px]" data-id="element-481">
            <img src={backgroundImageUrl} alt="AI Background" className="absolute inset-0 w-full h-full object-cover" data-id="element-482" />
          </div>
        </div>
      </div>
      {/* Content */}
      <div className="max-w-7xl mx-auto px-6 lg:px-24" data-id="element-483">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-484">
          {/* Features list - on left for larger screens */}
          <div className="relative z-10 flex-1 order-2 lg:order-1" data-id="element-485">
            <div className={`${backgroundColor} border-t border-benetton-green border-b border-benetton-green`} data-id="element-486">
              {features.map((feature, index) => <div key={index} className={`flex flex-col gap-8 py-8 ${index > 0 ? `border-t border-benetton-green` : ''}`} data-id="element-487">
                  <h3 className="text-2xl lg:text-3xl font-normal" data-id="element-488">
                    {feature.title}
                  </h3>
                  <div className="flex items-start gap-6 max-w-md" data-id="element-489">
                    <div className={`mt-0.5 ${accentColor} flex-shrink-0`} data-id="element-490">
                      <GreenArrowIcon data-id="element-491" />
                    </div>
                    <p className="text-base leading-relaxed text-gray-700 font-jakarta" data-id="element-492">
                      {feature.description}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
          {/* Title and description - on right for larger screens */}
          <div className="mb-12 lg:mb-0 order-1 lg:order-2 lg:h-[700px] flex items-start lg:items-center" data-id="element-493">
            <div className="max-w-lg lg:sticky lg:top-1/2 lg:transform lg:-translate-y-1/2" data-id="element-494">
              <h2 className="text-4xl lg:text-5xl font-normal leading-tight text-benetton-green font-apercu" data-id="element-495">
                Meet Naiomi.ai Your eCommerce Analyst
                {flagImageUrl && <img src={flagImageUrl} alt="Flag" className="inline-block h-8 max-h-12 ml-2 mb-3 object-contain" data-id="element-496" />}
              </h2>
              <p className="mt-4 text-lg text-gray-600 font-jakarta" data-id="element-497">
                Connect your apps and platforms in your eCommerce tech stack for
                deep insights across support, subscriptions sales and customer
                journeys.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}